export const MANUAL = 'MANUAL'
export const AUTO = 'AUTO'
export const DismissType = { MANUAL, AUTO }

export const DANGER = 'DANGER'
export const SUCCESS = 'SUCCESS'
export const WARNING = 'WARNING'
export const INFO = 'INFO'
export const Type = { DANGER, SUCCESS, WARNING, INFO }
